import { NgModule } from '@angular/core';
import { FavoriteComponent } from './favorite.component';
import { SharedProviderModule } from '../../shared/shared.module';
import { FavoriteService } from './favorite.service';
import { QmPipesModule } from '../../components/qm-pipes/qm-pipes.module';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    SharedProviderModule,
    NgbDropdownModule,
    NgbTooltipModule,
    QmPipesModule
  ],
  declarations: [FavoriteComponent],
  exports: [FavoriteComponent],
  providers: [FavoriteService]
})
export class FavoriteModule {
}
